import { ComboBox } from "../core/components/comboBox";
import { ComponentHelper } from "../core/util/componentHelper";
import { General } from "../../siteManagement/general";
import { SheetEventType, Sheet } from "../../siteManagement/sheet";
import React from "react";
export default class ProjectComboSearch extends React.Component<any, any> {
    private _componentFactory = ComponentHelper.createFactory();
    private _currentSheet: Sheet = null;

    constructor(props) {
        super(props)
        this._currentSheet = General.Sheet.Manager.getTopMostSheet();

    }

    private _openSearch = () => {
        const sheet = General.Sheet.Manager.createSheetWithUrl(this.props.field.searchWindowUrl, null, { disableTabTitle: true });
        sheet.setTitle(this.props.field.searchWindowTitle);
        //TODO: check "unmountComponent=false"
        sheet.destroyOnHide(false, this._currentSheet);
        sheet.bind(SheetEventType.RowClicked, (e) => {
            this.props.onChange(this.props.field, e, null)
        });
    }

    render() {
        const comboProps = this._componentFactory.getDefaultComboBoxProps();
        comboProps.commandManager = this.props.commandManager;
        comboProps.onChange = this.props.onChange;
        comboProps.onDataLoaded = () => { };
        comboProps.value = this.props.value;
        comboProps.disabled = this.props.disabled;
        comboProps.field.required = this.props.field.required;
        comboProps.field.model = this.props.field.model;
        comboProps.field.name = this.props.field.name;
        comboProps.field.dataSourceUrl = this.props.field.dataSourceUrl;
        comboProps.field.dataTextField = this.props.field.dataTextField;
        comboProps.field.dataValueField = this.props.field.dataValueField;

        return (
            <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
                <div style={{ flex: "1" }}>
                    <ComboBox {...comboProps} />
                </div>
                <span style={{ display: this.props.disabled ? "none" : "inline-block", marginLeft: 5 }}
                    title={this.props.field.searchWindowTitle} className="innoOptionsButton innoOptionsSearch" onClick={this._openSearch}></span>
            </div>
        );
    }
}